<script lang="ts">
  import { Card, Col, Container, Input, InputGroup, InputGroupText, Row } from "sveltestrap";
  import BookmarkSocialApp from "./BookmarkSocialApp.svelte";
  import {tempId} from "../../../store"
  import UserProfileHeader from "../Users/UserProfile/UserProfileHeader.svelte";
  import FeatherIcons from "svelte-feather-icon";
  import data from "../../../Data/SocialApp/SocialApp.json"
  import { href } from "../../../utils/Constant/Constant";
  import SocailTabContent from "./SocailTabContent.svelte";
    let setTempid:string
    tempId.subscribe((value)=>{
        setTempid = value
    })
    const handleTab= (getId:string)=>{
        tempId.update(value => value = getId)
    }

</script>
<BookmarkSocialApp />
<Container fluid>
    <div class="user-profile social-app-profile">
      <Row>
        <UserProfileHeader />
        <Col sm="12" class="box-col-12">
            <Card>                            
              <div class="social-tab">
                <ul class="nav nav-tabs" id="top-tab" role="tablist">
                    {#each data.socialtabdata as socialItem}
                        <li class="nav-item">
                            <a class="nav-link {setTempid === socialItem.id ? "active" : ""}" id={socialItem.id} href={href} role="tab" on:click={()=>handleTab(socialItem.id)}>
                                <FeatherIcons icon={socialItem.icon} />{socialItem.header}
                            </a>
                        </li>
                    {/each}
                </ul>
                <InputGroup>
                  <Input type="text" placeholder="Search......." />
                  <InputGroupText>
                     <i class="fa fa-search"></i>
                  </InputGroupText>
                </InputGroup>
              </div>
            </Card>
        </Col>
      </Row>
      <SocailTabContent />
    </div>
</Container>